module.exports = __webpack_public_path__ + "static/img/library.51854af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/secondToolList/library.png
// module id = WRPD
// module chunks = 3